import React from 'react';
import { get } from 'lodash/fp';
import { connect } from 'react-redux';
import EmptyStateAction from 'components/shared/EmptyStateAction';
import { hasGlobalFeature } from 'selectors';
import * as actions from 'actions/pathBuilder/contents';
import { blankViewOptions } from './stepOptions';

const mapPropsToActions = ({ features, isPublished, isCertification }) => {
  const { lesson, path, placeholder, demonstration, certification } =
    blankViewOptions;
  const result = [lesson];
  if (features.advancedPaths && (!isCertification || features.certifications))
    result.push(path);
  if (features.advancedPaths && features.certifications) {
    result.push(certification);
  }
  if (!isPublished) result.push(placeholder);
  if (features.demonstrations && isCertification) result.push(demonstration);
  return result;
};

const BlankView = ({ addNewContent, ...props }) => (
  <div className="PathBlankView">
    {mapPropsToActions(props).map(button => (
      <EmptyStateAction
        {...button}
        onClick={() => addNewContent(button.value)}
        key={button.value}
      />
    ))}
  </div>
);

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  isPublished: !!get('publishedAt.date')(pathBuilder),
  isCertification: !!get('certification')(pathBuilder),
  features: {
    advancedPaths: hasGlobalFeature(state, 'advanced_paths'),
    certifications: hasGlobalFeature(state, 'certifications'),
    demonstrations: hasGlobalFeature(state, 'demonstrations'),
  },
});

const mapDispatchToProps = dispatch => ({
  addNewContent(type) {
    dispatch(actions.add(type, 1));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BlankView);
